"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const react_router_1 = require("react-router");
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const striptags_1 = __importDefault(require("striptags"));
const company_profile_header_1 = require("./company-profile-header");
const company_profile_main_content_1 = require("./company-profile-main-content");
const CompanyProfileOffersContent_1 = require("./company-profile-offers-content/CompanyProfileOffersContent");
const CompanyProfile_style_1 = require("./CompanyProfile.style");
const CompanyProfile = ({ company }) => {
    const params = (0, react_router_1.useParams)();
    const contentType = Object.values(types_1.CompanyPremiumProfileContentType).includes(params.content)
        ? params.content
        : types_1.CompanyPremiumProfileContentType.profile;
    const companyImageUrl = (0, get_cdn_image_url_1.getCdnImageUrl)({
        shouldOptimizeQuality: false,
        file: `web/company/${company.titleImageUrl}`,
        transformation: `/w_1200,h_630,c_fill,g_faces,q_auto:best`,
    });
    const metaOfferDescription = (0, striptags_1.default)(company.description);
    return ((0, jsx_runtime_1.jsxs)(CompanyProfile_style_1.CompanyProfileMainPage, { children: [(0, jsx_runtime_1.jsx)(elements_1.Head, { title: company.name, description: metaOfferDescription, imageUrl: company.titleImageUrl ? companyImageUrl : undefined }), (0, jsx_runtime_1.jsx)(company_profile_header_1.CompanyProfileHeader, { contentTypeToShow: contentType, company: company }), contentType === types_1.CompanyPremiumProfileContentType.profile && ((0, jsx_runtime_1.jsx)(company_profile_main_content_1.CompanyProfileMainContent, { company: company })), contentType === types_1.CompanyPremiumProfileContentType.offers && ((0, jsx_runtime_1.jsx)(CompanyProfileOffersContent_1.CompanyProfileOffersContent, { company: company }))] }));
};
exports.CompanyProfile = CompanyProfile;
